import { render, staticRenderFns } from "./index.vue?vue&type=template&id=96a0283a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=96a0283a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a0283a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SplitPane: require('/Users/leo/Desktop/pc/zgszcy/components/split-pane/index.vue').default})
